import * as messageService from "../../services/message.service";
import * as referralPartnerService from '../../services/referralPartner.service';


const state = {
    referralPartnerAll:[],
    referralPartnerAllActive:[],
    referralPartnerPaginate:{},
    referralPartnerPaginateData:{},

    referralPartnerDropdownList:[],
};

const getters = {
    getReferralPartnerAll:state => (state.referralPartnerAll),
    getReferralPartnerAllActive:state => (state.referralPartnerAllActive),
    getReferralPartnerPaginate:state => (state.referralPartnerPaginate),
    getReferralPartnerPaginateData:state => (state.referralPartnerPaginateData),
    getReferralPartnerDropdownList:state => (state.referralPartnerDropdownList),
};

const actions = {
    async fetchReferralPartnerAll({ commit } ){
        try {
            const response = await referralPartnerService.all();
            commit('setReferralPartnerAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchReferralPartnerAllActive({ commit } ){
        try {
            const response = await referralPartnerService.allActive();
            commit('setReferralPartnerAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchReferralPartnerPaginate({ commit }, obj){
        commit('setReferralPartnerPaginate', obj)
        try {
            const response = await referralPartnerService.listPage(obj);

            commit('setReferralPartnerPaginateData', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchReferralPartnerPaginate', error);
        }
    },
    async fetchReferralPartnerDropdownList({ commit }, partner_type){
        try {
            const response = await referralPartnerService.dropdownList(partner_type);

            commit('setReferralPartnerDropdownList', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchReferralPartnerDropdownList', error);
        }
    },
};

const mutations = {
    setReferralPartnerAll:(state, res) => (
        state.referralPartnerAll =  res
    ),
    setReferralPartnerAllActive:(state, res) => (
        state.referralPartnerAllActive =  res
    ),
    setReferralPartnerPaginateData:(state, res) => (
        state.referralPartnerPaginateData =  res
    ),
    setReferralPartnerPaginate:(state, res) => (
        state.referralPartnerPaginate =  res
    ),
    setReferralPartnerDropdownList:(state, res) => (
        state.referralPartnerDropdownList =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}